
















































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { Collection } from '@/resource/collection/collection.model';
import MainButton from '@/main-components/common/MainButton.vue';
import Icon from '@/main-components/common/Icon.vue';
import truncateString from '@/utils/common/truncate';

@Component({
  components: { MainButton, Icon },
})
export default class PaperItem extends Vue {
  @Prop()
  paper: Collection;

  @Inject('colorBrandDarkPrimary')
  colorBrandDarkPrimary!: string;

  @Inject('colorBlackPrimary')
  colorBlackPrimary!: string;

  @Prop({ required: true })
  onDeleteClick: (paperId: number) => void;

  get formattingDate() {
    return this.$dayjs(this.paper.updatedAt).format('D MMM, YYYY');
  }

  get formattingTime() {
    return this.$dayjs(this.paper.updatedAt).format('ha');
  }

  get paperName() {
    return truncateString(this.paper.name, 38);
  }

  get paperLink() {
    return { name: 'paper', params: { uuid: this.paper.uuid } };
  }
}
